<div class="main-wrapper">
    <app-sidenav></app-sidenav>
    <div class="playground-wrapper">
        <div class="playground">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>